import { z } from 'zod';
import { EMAIL_ERROR_MESSAGE, EMAIL_PATTERN } from './policies/email.js';
export const emailSchema = z
    .string()
    .regex(EMAIL_PATTERN, EMAIL_ERROR_MESSAGE)
    .toLowerCase();
//# sourceMappingURL=email.js.map